// extracted by mini-css-extract-plugin
export default {"button":"Button_button__85C4R","loading":"Button_loading__DVjZJ","default":"Button_default__vIFpo","outline":"Button_outline__k6p3p"};